// extracted by mini-css-extract-plugin
export var downArrow = "_58-0";
export var label = "_58-1";
export var upArrow = "_58-2";